<template>
  <v-dialog v-model="dialog" max-width="1200" persistent scrollable>
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-on="on" v-bind="attrs" icon color="secondary" title="Cadpro"
        ><v-icon>mdi-list-box-outline</v-icon></v-btn
      >
    </template>
    <v-card>
      <v-card-title class="font-weight-bold">{{ cliente.nome }}</v-card-title>
      <v-card-subtitle>Cadpro(s) do cliente</v-card-subtitle>

      <v-card-text>
        <btn-manut-cad-pro :cadpro="null" :cliente="cliente" />
        <v-data-table          
          class="mt-3"
          :items="cadpros"
          :headers="headers"
          no-data-text="Nenhum cadpro encontrado"
        >
          <template v-slot:[`item.descstatus`]="{ item }">
            <v-chip x-small v-if="item.status == 0" color="success">{{
              item.descstatus
            }}</v-chip>
            <v-chip x-small v-else color="error">{{ item.descstatus }}</v-chip>
          </template>
          <template v-slot:[`item.emissao`]="{ item }">
            {{ formatarData(item.emissao) }}
          </template>
          <template v-slot:[`item.vcto`]="{ item }">
            {{ formatarData(item.vcto) }}
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <btn-manut-cad-pro :cadpro="item" :cliente="cliente" />
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="dialog = false" text rounded>Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
import BtnManutCadPro from "./BtnManutCadPro.vue";
import { mapActions, mapState } from "vuex";
export default {
  props: {
    cliente: Object,
  },
  components: {
    BtnManutCadPro,
  },
  watch: {
    dialog: async function (open) {
      if (open) {
        this.loading = true;
        await this.getCadpros({ pesquisa: this.cliente.matricula });
        this.loading = false;
      }
    },
  },
  computed: mapState("clientes", ["cadpros"]),
  data: () => ({
    dialog: false,
    loading: true,
    headers: [
      { text: "Nº Cadpro", value: "nrcadpro" },
      { text: "Descrição", value: "descricao" },
      { text: "Município", value: "cidade" },
      { text: "Endereço", value: "endereco" },
      { text: "Emissão", value: "emissao" },
      { text: "Vcto", value: "vcto" },
      { text: "Incra", value: "incra" },
      { text: "Tam. Imóvel", value: "tamanhoimovel" },
      { text: "Status", value: "descstatus" },
      { text: "", value: "actions" },
    ],
  }),
  methods: {
    ...mapActions("clientes", ["getCadpros"]),
    isMobile() {
      return this.$mq == "sm";
    },
    formatarData(value) {
      if (value) return moment(value).format("DD/MM/yyyy");

      return "";
    },
  },
};
</script>

<style>
</style>